export enum GridColumnName {
  /** @deprecated */
  Card = 'grid-card',
  Expand = 'grid-expand',
  ExpandedDetail = 'grid-expanded-detail',
  Fill = 'grid-fill',
  Menu = 'grid-menu',
  Select = 'grid-select'
}
